var youbora = require('youboralib')
var manifest = require('../../manifest.json')

var BrightcoveAdsAdapter = youbora.Adapter.extend({
  getVersion: function () {
    return manifest.version + '-videojs-bcove-ads'
  },

  getPlayhead: function () {
    return this.player.ima3.adPlayer.currentTime()
  },

  getPosition: function () {
    if (this.plugin._adapter) {
      if (this.plugin._adapter.getPlayhead() + 1 > this.plugin._adapter.getDuration()) {
        return 'post'
      } else if (this.plugin._adapter.flags.isJoined && this.plugin._adapter.getPlayhead() > 1) {
        return 'mid'
      }
    }
    return 'pre'
  },

  getResource: function () {
    return "unknown"
  },

  getTitle: function () {
    if (this.player.ima3) {
      if (this.player.ima3 && this.player.ima3.currentAdEventInfo && this.player.ima3.currentAdEventInfo.adTitle) {
        return this.player.ima3.currentAdEventInfo.adTitle[0]
      }
      return null
    }
    return "unknown"
  },

  getDuration: function () {
    if (this.player.ima3 && this.player.ima3.currentAd && this.player.ima3.currentAd.g) {
      this.lastDuration = this.player.ima3.currentAd.g.duration
      return this.lastDuration
    }
  },

  getPlayerName: function () {
    return 'bcove-ads'
  },

  getPlayerVersion: function () {
    if (this.player.ima3)
      return this.player.ima3.VERSION
    return null
  },

  registerListeners: function () {
    // Console all events if logLevel=DEBUG
    youbora.Util.logAllEvents(this.player, [
      null,
      'ima3-ready',
      'ima3error',
      'ima3-ad-error',
      'ima3-started',
      'ima3-complete',
      'ima3-paused',
      'ima3-resumed',
      'ads-request',
      'ads-load',
      'ads-ad-started',
      'ads-ad-ended',
      'ads-pause',
      'ads-play',
      'ads-click',
      'ads-pod-started',
      'ads-pod-ended',
      'ads-allpods-completed'
    ])

    // Enable playhead monitor
    this.monitorPlayhead(true, false)

    // Register listeners
    this.references = []
    this.references['ima3-started'] = this.imaStartedListener.bind(this)
    this.references['ima3-paused'] = this.imaPausedListener.bind(this)
    this.references['ima3-resumed'] = this.imaResumedListener.bind(this)
    this.references['ima3-complete'] = this.imaCompleteListener.bind(this)
    this.references['ima3-skipped'] = this.imaSkippedListener.bind(this)
    this.references['ima3-ad-error'] = this.errorListener.bind(this)
    this.references['adserror'] = this.errorListener.bind(this)
    this.references['ads-click'] = this.clickListener.bind(this)
    for (var key in this.references) {
      this.player.on(key, this.references[key])
    }
  },

  imaStartedListener: function (e) {
    if (this.plugin._adapter) this.plugin._adapter.firePause()
    this.fireStart()
    this.fireJoin()
  },

  imaPausedListener: function (e) {
    this.firePause()
  },

  imaResumedListener: function (e) {
    this.fireResume()
  },

  imaCompleteListener: function (e) {
    this.fireStop({ adPlayhead: this.lastDuration })
    if (this.plugin._adapter) this.plugin._adapter.fireResume()
  },

  imaSkippedListener: function (e) {
    this.fireStop({ skipped: true })
    if (this.plugin._adapter) this.plugin._adapter.fireResume()
  },

  errorListener: function (e) {
    this.fireError('Ad error')
  },

  clickListener: function (e) {
    var clickurl = null
    if (this.player.ima3 && this.player.ima3.currentAd && this.player.ima3.currentAd.g) {
      clickurl = this.player.ima3.currentAd.g.clickThroughUrl
    }
    this.fireClick({ 'url': clickurl })
  },

  unregisterListeners: function () {
    // Disable playhead monitoring
    this.monitor.stop()

    // unregister listeners
    if (this.player && this.references) {
      for (var key in this.references) {
        this.player.off(key, this.references[key])
      }
      this.references = []
    }
  }
},
  // Static Members
  {
    isUsed: function (plugin) {
      return plugin.player.ima || plugin.player.ima3
    }
  }
)

module.exports = BrightcoveAdsAdapter
